import { Component, inject } from '@angular/core';
import {
  Router,
  RouterOutlet,
  NavigationStart,
  NavigationEnd,
  NavigationCancel,
  NavigationError,
} from '@angular/router';

import { CoreService } from './services/core.service';
import { LoaderComponent } from './shared/components/loader/loader.component';
import { NetworkStatusComponent } from './shared/components/network-status/network-status.component';
import { UserService } from './core/services/user.service';
import {
  combineLatest,
  concatMap,
  EMPTY,
  forkJoin,
  switchMap,
  take,
} from 'rxjs';
import { AuthService } from './pages/authentication/auth.service';
import { RoleService, RoleType } from './core/services/role.service';
import { ToastService } from './shared/services/toast.service';
import { LoaderService } from './shared/components/loader/loader.service';
import { ScrollService } from './shared/services/scroll.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, LoaderComponent, NetworkStatusComponent],
  templateUrl: './app.html',
})
export class App {
  title = 'Zuntime';
  router = inject(Router);
  scrollSvc = inject(ScrollService);

  userSvc = inject(UserService);
  authSvc = inject(AuthService);
  toastSvc = inject(ToastService);
  roleSvc = inject(RoleService);
  loaderSvc = inject(LoaderService);
  constructor() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.loaderSvc.show();
      }
      if (
        event instanceof NavigationEnd ||
        event instanceof NavigationCancel ||
        event instanceof NavigationError
      ) {
        this.loaderSvc.hide();
      }
      if (event instanceof NavigationEnd) {
        this.scrollSvc.restoreScrollPosition({ scrollX: 0, scrollY: 0 });
      }
    });
  }
  ngOnInit(): void {
    // call user if user$ is null
    if (this.authSvc.isUserLoggedIn()) {
      this.roleSvc
        .getRoles()
        .pipe(switchMap(() => this.userSvc.getProfile()))
        .subscribe();
    }
  }
}
